var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.stars)?_c('div',{staticClass:"stars"},_vm._l((_vm.stars),function(i){return _c('i',{key:i,staticClass:"stars__icon"})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }